import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_PURCHASE_ORDER_HISTORY } from 'Store/FleetManagement/FleetPurchaseOrderHistory/FleetPurchaseOrderHistoryType';
import { setFleetPurchaseOrderHistory } from 'Store/FleetManagement/FleetPurchaseOrderHistory/FleetPurchaseOrderHistoryAction';

const getResponseData = (payload?: any, response?: any, fleetPOHistoryTemp?: any) => {
    let result = {}
    result = {
        id: payload.fleetDetailId,
        response: response,
        isOpen: true,
        pageNumber: payload.pageNumber,
        pageSize: payload.pageSize
    };
    fleetPOHistoryTemp?.push(result);
    return fleetPOHistoryTemp;
}
function* GetPurchaserOrderHistorySaga(req: any): any {
    const fleetPurchaseOrderHistory = yield select(
        (state: any) =>
            state?.FleetPurchaseOrderHistoryReducers?.fleetPurchaseOrderHistory
    );
    let fleetPOHistoryTemp = [];
    if (fleetPurchaseOrderHistory?.length) {
        fleetPOHistoryTemp = fleetPurchaseOrderHistory?.filter(
            (filterItem?: any) => filterItem?.id != req?.payload?.fleetDetailId
        );
    }
    try {
        yield put(globalLoaderText("Get Purchase Order History...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `fleet/purchaseOrderHistory`,
            apiMethod: apiMethod.POST,
            payload: req?.payload
        }
        const response = yield call(
            FleetManagementApiService.post, API_URL.PostWebApp, payloadData
        );

        if (response?.data.length) {
            getResponseData(req?.payload, response, fleetPOHistoryTemp)
            yield put(setFleetPurchaseOrderHistory(fleetPOHistoryTemp))
            yield put(globalLoaderText(""));
        } else {
            getResponseData(req?.payload, {}, fleetPOHistoryTemp)
            yield put(setFleetPurchaseOrderHistory(fleetPOHistoryTemp))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        getResponseData(req?.payload, {}, fleetPOHistoryTemp)
        yield put(setFleetPurchaseOrderHistory(fleetPOHistoryTemp))
        yield put(globalLoaderText(""));
    }
}

function* watchGetPOHistory() {
    yield takeEvery(GET_PURCHASE_ORDER_HISTORY, GetPurchaserOrderHistorySaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetPOHistory()
    ])
}
